import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';

import ukuleleIcon from 'assets/img/UkuleleIconLanding.png';

import URLS from 'URLS';

const BANNER_URL = `${URLS.CALENDLY}?utm_source=landing&utm_medium=banner&utm_campaign=free-ukuleles`;

const UkuleleBanner = () => {
  const { t } = useTranslation('common');

  return (
    <Box
      component='a'
      href={BANNER_URL}
      rel='noopener noreferrer'
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        width: '100%',
        minHeight: 48,
        p: '12px',
        backgroundColor: '#1268c8',
        color: '#fff000',
        fontWeight: 700,
        fontSize: '16px',
        letterSpacing: '0.2px',
        textDecoration: 'none',
        textShadow: '-1px -1px 0 #0a1f3d, 1px -1px 0 #0a1f3d, -1px 1px 0 #0a1f3d, 1px 1px 0 #0a1f3d, 0 3px 6px rgba(0,0,0,0.45)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        transition: 'filter .15s',
        '&:hover': { filter: 'brightness(1.12)' },
        '& .banner-long, & .banner-medium, & .banner-icon': { display: 'none' },
        '& .banner-short': { display: 'inline' },
        [theme.breakpoints.up(390)]: { '& .banner-short': { display: 'none' }, '& .banner-medium': { display: 'inline' } },
        [theme.breakpoints.up(768)]: {
          minHeight: 56,
          p: '10px 24px',
          gap: '12px',
          fontSize: 'clamp(18px, 1.2vw + 4px, 22px)',
          '& .banner-medium': { display: 'none' },
          '& .banner-long': { display: 'inline' },
          '& .banner-icon': { display: 'inline-flex' },
        },
      })}
      target='_blank'>
      <Box alt='' className='banner-icon' component='img' src={ukuleleIcon} sx={{ width: 32, height: 32, flexShrink: 0 }} />
      <span className='banner-long'>{t('LANDING.UKULELEBANNER.LONG')}</span>
      <span className='banner-medium'>{t('LANDING.UKULELEBANNER.MEDIUM')}</span>
      <span className='banner-short'>{t('LANDING.UKULELEBANNER.SHORT')}</span>
    </Box>
  );
};

export default UkuleleBanner;
